import revive_payload_client_4sVQNw7RlN from "/var/www/frontend/c-rent-client-vue/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import unhead_KgADcZ0jPj from "/var/www/frontend/c-rent-client-vue/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "/var/www/frontend/c-rent-client-vue/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import _0_siteConfig_jtc2qNDx4l from "/var/www/frontend/c-rent-client-vue/node_modules/nuxt-site-config/dist/runtime/app/plugins/0.siteConfig.js";
import payload_client_yVLowv6hDl from "/var/www/frontend/c-rent-client-vue/node_modules/nuxt/dist/app/plugins/payload.client.js";
import navigation_repaint_client_bs2bWDGRIE from "/var/www/frontend/c-rent-client-vue/node_modules/nuxt/dist/app/plugins/navigation-repaint.client.js";
import check_outdated_build_client_8vK7RkfGxZ from "/var/www/frontend/c-rent-client-vue/node_modules/nuxt/dist/app/plugins/check-outdated-build.client.js";
import chunk_reload_client_UciE0i6zes from "/var/www/frontend/c-rent-client-vue/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import plugin_vue3_YdLad5Mpq3 from "/var/www/frontend/c-rent-client-vue/node_modules/@pinia/nuxt/dist/runtime/plugin.vue3.js";
import components_plugin_KR1HBZs4kY from "/var/www/frontend/c-rent-client-vue/.nuxt/components.plugin.mjs";
import prefetch_client_5tzzN0oIVL from "/var/www/frontend/c-rent-client-vue/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import nuxt_plugin_6wEQMY3tee from "/var/www/frontend/c-rent-client-vue/node_modules/nuxt-delay-hydration/dist/runtime/nuxt-plugin.js";
import plugin_tbFNToZNim from "/var/www/frontend/c-rent-client-vue/node_modules/@zadigetvoltaire/nuxt-gtm/dist/runtime/plugin.mjs";
import plugin_client_UYiXMU8ZyN from "/var/www/frontend/c-rent-client-vue/node_modules/nuxt-gtag/dist/runtime/plugin.client.js";
import plugin_Jozdw60ZsE from "/var/www/frontend/c-rent-client-vue/node_modules/dayjs-nuxt/dist/runtime/plugin.js";
import plugin_WLsn00x1qh from "/var/www/frontend/c-rent-client-vue/node_modules/@nuxt/icon/dist/runtime/plugin.js";
import wait_8smOKXbEa2 from "/var/www/frontend/c-rent-client-vue/node_modules/maz-ui/nuxt/runtime/plugins/wait.js";
import dialog_oskbpOXjaP from "/var/www/frontend/c-rent-client-vue/node_modules/maz-ui/nuxt/runtime/plugins/dialog.js";
import toaster_075gpxZKPU from "/var/www/frontend/c-rent-client-vue/node_modules/maz-ui/nuxt/runtime/plugins/toaster.js";
import v_tooltip_W0xMOoBSGU from "/var/www/frontend/c-rent-client-vue/node_modules/maz-ui/nuxt/runtime/plugins/v-tooltip.js";
import v_fullscreen_img_WptxiGlBWJ from "/var/www/frontend/c-rent-client-vue/node_modules/maz-ui/nuxt/runtime/plugins/v-fullscreen-img.js";
import v_click_outside_IdCIvdx3Bz from "/var/www/frontend/c-rent-client-vue/node_modules/maz-ui/nuxt/runtime/plugins/v-click-outside.js";
import v_lazy_img_AIpZniU600 from "/var/www/frontend/c-rent-client-vue/node_modules/maz-ui/nuxt/runtime/plugins/v-lazy-img.js";
import v_zoom_img_fOWOznjIMT from "/var/www/frontend/c-rent-client-vue/node_modules/maz-ui/nuxt/runtime/plugins/v-zoom-img.js";
import aos_mKDFTpG042 from "/var/www/frontend/c-rent-client-vue/node_modules/maz-ui/nuxt/runtime/plugins/aos.js";
import switch_locale_path_ssr_5csfIgkrBP from "/var/www/frontend/c-rent-client-vue/node_modules/@nuxtjs/i18n/dist/runtime/plugins/switch-locale-path-ssr.js";
import i18n_sq1MuCrqbC from "/var/www/frontend/c-rent-client-vue/node_modules/@nuxtjs/i18n/dist/runtime/plugins/i18n.js";
import google_recaptcha_client_VwhKLB8VKY from "/var/www/frontend/c-rent-client-vue/plugins/google-recaptcha.client.ts";
import axios_QMFgzss1s4 from "/var/www/frontend/c-rent-client-vue/plugins/axios.ts";
import fetch_14DdzPiXUB from "/var/www/frontend/c-rent-client-vue/plugins/fetch.ts";
import maz_toaster_q5S7Jopzgy from "/var/www/frontend/c-rent-client-vue/plugins/maz-toaster.ts";
export default [
  revive_payload_client_4sVQNw7RlN,
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  _0_siteConfig_jtc2qNDx4l,
  payload_client_yVLowv6hDl,
  navigation_repaint_client_bs2bWDGRIE,
  check_outdated_build_client_8vK7RkfGxZ,
  chunk_reload_client_UciE0i6zes,
  plugin_vue3_YdLad5Mpq3,
  components_plugin_KR1HBZs4kY,
  prefetch_client_5tzzN0oIVL,
  nuxt_plugin_6wEQMY3tee,
  plugin_tbFNToZNim,
  plugin_client_UYiXMU8ZyN,
  plugin_Jozdw60ZsE,
  plugin_WLsn00x1qh,
  wait_8smOKXbEa2,
  dialog_oskbpOXjaP,
  toaster_075gpxZKPU,
  v_tooltip_W0xMOoBSGU,
  v_fullscreen_img_WptxiGlBWJ,
  v_click_outside_IdCIvdx3Bz,
  v_lazy_img_AIpZniU600,
  v_zoom_img_fOWOznjIMT,
  aos_mKDFTpG042,
  switch_locale_path_ssr_5csfIgkrBP,
  i18n_sq1MuCrqbC,
  google_recaptcha_client_VwhKLB8VKY,
  axios_QMFgzss1s4,
  fetch_14DdzPiXUB,
  maz_toaster_q5S7Jopzgy
]